<template>
    <div class="m-invite">
        <h5 class="title"></h5>
        <div class="slogen">
            <div class="text">
                <p>邀请符合条件的回归老兵接受您的专属链接，登录游戏并在【玩家回归】界面接收招募邀请，即算邀请成功，</p>
                <p>邀请人可获得情义积分！（回归老兵也可邀请回归玩家，获取情义积分）</p>
            </div>
        </div>
        
        <div class="u-ctrl">
            <div class="u-btn friend-list" @click="call_record()"></div>
            <div class="u-btn rule" @click="$rule_modal()"></div>            
        </div>

        <div class="page-view">
            <div class="invite-body">
                <div class="invite-panel">
                    <div class="friend-view">
                        <div class="friend-item act" v-for="(item,index) in friend_list" :key="item.uid">
                            <div class="friend-wrapper">
                                <div class="avatar">
                                    <img :src="require('@/assets/images/avatar/'+ (index + 1) +'.png')" :alt="item.uid">
                                </div>
                            </div>

                            <!-- <p class="player-name">{{ item.nickName }}</p>                         -->
                        </div>
                        <div class="friend-item wait" v-for="n in (4 - friend_list.length)" :key="n">
                            <div class="friend-wrapper">
                                <div class="add u-btn" @click="call_invite()"></div>
                            </div>
                            <!-- <p class="state">待邀请</p>                         -->
                        </div>
                    </div>

                    <div class="reward-view">
                        <div class="reward-item" :class="'i-' + (index + 1)" v-for="(item,index) in reward_list" :key="index">
                            <div class="reward-bg" :class="{'dismiss' : index < giftRate , 'act' : friend_list.length > index && index >= giftRate}">
                                <div class="r-wrapper">
                                    <div class="pic" v-tips="item.giftId">
                                        <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                    </div>
                                </div>                             
                            </div>
                            
                            <div class="u-btn apply" v-if="friend_list.length > index && index >= giftRate" @click="apply(index + 1,[reward_list[index]])"></div>
                            <div class="status" :class="{'dismiss' : index < giftRate}" v-else></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="u-btn invite" @click="call_invite()"></div>
        </div>
    </div>
</template>

<style scoped>
.title{
    width: 1111px;
    height: 173px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/title-2.png);
}

.invite-body{
    /* display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto; */
    width: 1282px;
    height: 592px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/bg-invite-panel.png);
}

.u-ctrl{
    display: flex;
    justify-content: center;
    width: 400px;
    margin: 20px auto 0;
}

.u-ctrl .text{
    margin-top: 20px;
    padding: 0 30px;
    font-size: 16px;
    color: #49392e;
}

.u-btn.friend-list{
    width: 157px;
    height: 42px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/pc/btn-record_invite.png);
}

.u-btn.rule{
    width: 157px;
    height: 42px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/pc/btn-rule_back.png);
}

.invite-panel{
    position: relative;
}

.u-btn.invite{
    position: relative;
    width: 285px;
    height: 103px;
    margin: 55px auto 0;
    transform: translateX(-10px);
    background-image: url(~@/assets/images/pc/btn-invite.png);    
}

.friend-view{
    display: flex;
    justify-content: space-between;
    width: 1064px;
    padding-top: 80px;
    margin:  0 auto 0;   
}

.friend-wrapper{
    position: relative;
    width: 172px;
    height: 172px;
    background-image: url(~@/assets/images/pc/bg-avatar.png); 
}

.friend-item .avatar{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 156px;
    height: 156px;
    border-radius: 50%;
    overflow: hidden;
}

.avatar img{
    width: 100%;
    height: 100%;
}

.u-btn.add{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 64px;
    height: 64px;
    /* background-image: url(~@/assets/images/pc/btn-add.png);          */
}

.reward-view{
    display: flex;
    justify-content: space-between;
    width: 1186px;
    padding: 66px 60px 0;
    margin:  17px auto 0;
    background-image: url(~@/assets/images/pc/bg-pro.png); 
    background-position: top center;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.reward-item{
    width: 172px;
}


.reward-bg{
    position: relative;
    left: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    margin: 0 auto;
    transform: translateX(-5px);
    background-image: url(~@/assets/images/pc/bg-item_2.png);
}

.i-4 .reward-bg{
    transform: translateX(-10px);
}

.r-wrapper{
    width: 46px;
    margin: 0 auto;
}

.r-wrapper .pic{
    width: 46px;
    height: 46px;
}

.reward-view .status{
    position: relative;
    left: 8px;    
    width: 179px;
    height: 67px;
    margin: 26px auto 0;
    transform: translateX(-8px);
    background-image: url(~@/assets/images/pc/btn-task_apply_disabled.png);
}

.reward-view .status.dismiss{
    width: 142px;
    height: 60px;
    margin: 10px auto;
    background-image: url(~@/assets/images/pc/status-dismiss.png);    
}

.reward-view .u-btn.apply{
    width: 179px;
    height: 67px;
    margin: 26px auto 0;
    transform: translateX(-8px);
    background-image: url(~@/assets/images/pc/btn-apply.png);    
}
</style>

<script>
export default {
    data (){
        return {
            friend_list : [],
            giftRate : 0,
            finishRate : 0,
            reward_list : [],
        }
    },
    mounted (){
        this.render();
        this.get_list();
    },
    methods : {
        render (){
            var _this = this;
            this.$axios.get(ajax_url_map.friend_list,{
                params : {
                    mode : 2
                }
            })
            .then(res => {
                this.friend_list = res.data.list ? res.data.list.splice(0,4) : [];
                this.giftRate = res.data.giftRate;
            },rej => {
                //_this.$toast(rej.message)
            });            
        },
        get_list(){
            var _this = this;
            this.$axios.get(ajax_url_map.share_config,{
                params : {
                    mode : 2
                }
            })
            .then(res => {
                this.config = res.data['2'] ? res.data['2'] : [];
                this.reward_list = this.config.aGiftList;
            },rej => {
                //_this.$toast(rej.message)
            });              
        },
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            this.$copy_modal({mode : 2});
        },
        call_record(){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            this.$friend_list();
        },
        apply(index,list){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            this.$axios.post(ajax_url_map.share_apply,{
                index : index,
                mode : 2,
            })
            .then(
                res => {
                    //this.$toast('领取成功');
                    this.$success_modal({'text' : '奖励已发放至活动页面，请及时领取' , giftList : list});
                    this.$update_user();
                    this.render();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )             
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/view/invite.vue